//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data() {
		return {
			produtos: [
				{
					nome: 'Faculdade Multiversa',
					img: '/produtos/t-04.png',
					url: '/',
				},
				// {
				//   nome: 'Portal de Turismo e Hotelaria',
				//   img: '/produtos/t-01.png',
				//   url: '/portal-de-turismo-e-hotelaria',
				// },
				// {
				//   nome: 'Colégio Multiversa',
				//   img: '/produtos/t-03.png',
				//   url: '/colegio-multiversa',
				// },
				{
					nome: 'Centro Integrado de Saúde',
					img: 'produtos/t-05.png',
					url: 'https://cis.uniamerica.br/',
				},
				{
					nome: 'Hub de Inovação',
					img: '/produtos/t-08.png',
					url: '/hub-e21',
				},
				{
					nome: 'Neoperspectiva Consultoria',
					img: '/produtos/t-09.png',
					url: 'https://neoperspectiva.com.br',
				},
				// {
				//   nome: 'Gestão Interina de IES',
				//   img: '/produtos/t-01.png',
				//   url: '/gestao-interina-de-ies',
				// },
			],
		}
	},
}
